import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { PageMetaResolver } from '@spartacus/core';
import { effects } from './effects';
import { AccountPageMetaResolver } from './resolvers';

@NgModule({
  imports: [EffectsModule.forFeature(effects)],
  providers: [
    {
      provide: PageMetaResolver,
      useExisting: AccountPageMetaResolver,
      multi: true,
    },
  ],
})
export class MyAccountFeatureModule {}
